import Command from '@ckeditor/ckeditor5-core/src/command';

export default class InsertCollapsableCommand extends Command {
    execute() {
        this.editor.model.change( writer => {
            // Insert <collapsable>*</collapsable> at the current selection position
            // in a way that will result in creating a valid model structure.
            this.editor.model.insertContent( createCollapsable( writer ) );
        } );
    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = model.schema.findAllowedParent( selection.getFirstPosition(), 'collapsable' );

        this.isEnabled = allowedIn !== null;
    }
}

function createCollapsable( writer ) {
    const collapsable = writer.createElement( 'collapsable' );
    const collapsableTitle = writer.createElement( 'collapsableTitle' );
    const collapsableDescription = writer.createElement( 'collapsableDescription' );

    writer.append( collapsableTitle, collapsable );
    writer.append( collapsableDescription, collapsable );

    // There must be at least one paragraph for the description to be editable.
    // See https://github.com/ckeditor/ckeditor5/issues/1464.
    writer.appendElement( 'paragraph', collapsableDescription );

    return collapsable;
}